import React, { useContext, useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { WONDE_STUDENTS_UPN_MATCH } from "../../services/graphql";
import { AuthContext } from "../../../../services/auth/AuthProvider";
import loader from '../../../../images/loader.svg';
import UpnMatchContent from "./UpnMatchContent";
import { WONDE_SYNC_STEPS } from "../../../../services/constants";

const UpnMatchQuery = ({ setCurrentStep }) => {

    const { currentUser } = useContext(AuthContext);

    const [showIntro, setShowIntro] = useState(true);

    const { data, loading, error } = useQuery(WONDE_STUDENTS_UPN_MATCH, {
        variables: {
            schoolId: currentUser?.school?.id
        },
        onCompleted: ({ school }) => {
            if (school?.wondeAutoMatchStudentsByUpn?.length === 0) {
                setCurrentStep(WONDE_SYNC_STEPS.syncStudentsSuggested);
            }
        }
    });

    if (error) {
        return <p>{error.message}</p>
    }

    return (
        <>

            {loading ?
                <>
                    <p className="u-display-flex u-align-center heavy">Please wait, loading students... <img className="u-m-left-2" src={loader} /></p>
                </> :
                data?.school?.wondeAutoMatchStudentsByUpn?.length > 0 &&
                <UpnMatchContent
                    school={currentUser?.school}
                    setCurrentStep={setCurrentStep}
                    allStudents={data.school.wondeAutoMatchStudentsByUpn}
                />
            }
        </>
    )

}

export default UpnMatchQuery;